import { cn } from '@mdvip/shared/lib/utils';
import type * as React from 'react';

/**
 * One labelled metric column for `PaymentSummaryCard`'s wide grouped layout — the inline
 * equivalent of a bare StatTile. `label` accepts a node (not just a string) so a loading metric
 * can pass a `<Skeleton>` in its place.
 */
export function Metric({
  label,
  className,
  children,
  ...props
}: { label: React.ReactNode; children: React.ReactNode } & React.ComponentProps<'div'>) {
  return (
    <div className={cn('min-w-0', className)} {...props}>
      <div className="text-sm text-muted-foreground">{label}</div>
      <div className="mt-1.5">{children}</div>
    </div>
  );
}
